const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  saveAutoship ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/userbelog/save-autoship', params)
  },
  deleteAutoship ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/userbelog/delete-autoship', params)
  },
  // 查询久久会员状态
  searchLong91 ({ state, commit, rootState }, params) {
    return rootState.axios.get('/user/v1frontend/userbelog/search-long91', params)
  },
  // 开通久久会员
  createLong91 ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/userbelog/create-long91', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
